import { Button, ButtonProps } from "@chakra-ui/react"
import Pathicon from "@pathwright/features/src/modules/pathicon/Pathicon"
import { useFormikContext } from "formik"

function FormSubmitButton({ disabled, ...props }: ButtonProps) {
  const form = useFormikContext()

  return (
    <Button
      type="submit"
      variant="solid"
      size="lg"
      w="100%"
      cursor={form.isValid ? "pointer" : "disabled"}
      // disabled={!form.isValid || form.isSubmitting || props.loading}
      // loading={form.isSubmitting}
      disabled={!form.isValid || props.loading || disabled}
      loading={props.loading}
      {...props}
    >
      Add Path
      <Pathicon icon="chevron-right" />
    </Button>
  )
}

export default FormSubmitButton
